import axios from "axios";
import baseUrl from "./baseURL";

export default axios.create({
    baseURL: baseUrl(),
    timeout: 60000*5,
    headers: {
        "Content-type": "application/json",
        "Authorization":'Bearer '+sessionStorage.getItem('access')
    }
});

